module.exports = __webpack_public_path__ + "media/images/zl_w-2bcba2f752dda7246c3e71aa6eb01738.png";